import styles from './ScoopCenter.module.scss'

/**
 * ScoopCenter - Centered flex container component (horizontally and vertically)
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child elements
 * @param {string} [props.className=''] - Additional CSS classes
 * @param {string|number} [props.gap] - Gap between children (e.g., '8px', 16, '1rem')
 * @param {boolean} [props.fullWidth=false] - Set width to 100%
 * @param {boolean} [props.fullHeight=false] - Set height to 100%
 * @param {Object} [props.style] - Additional inline styles
 * @param {Object} props...rest - Additional HTML div props
 */
export const ScoopCenter = ({
    children,
    className = '',
    gap,
    fullWidth = false,
    fullHeight = false,
    style,
    ...rest
}) => {
    const inlineStyles = {
        ...(gap !== undefined && { gap: typeof gap === 'number' ? `${gap}px` : gap }),
        ...(fullWidth && { width: '100%' }),
        ...(fullHeight && { height: '100%' }),
        ...style,
    }

    const hasInlineStyles = Object.keys(inlineStyles).length > 0

    return (
        <div
            className={`${styles.center} ${className}`.trim()}
            style={hasInlineStyles ? inlineStyles : undefined}
            {...rest}
        >
            {children}
        </div>
    )
}

export default ScoopCenter
